<!-- 记工流水列表、记工统计列表、记工统计-工人列表-->
<template>
  <div class="statistics-wrap">
    <div class="project_name"><span class="color666">当前项目：</span>{{ project.projectName }}</div>
    <el-tabs value="water" v-model="curTab" @tab-click="tabClick">
      <el-tab-pane label="记工流水" name="water">
        <Water ref="water" :project="project"></Water>
      </el-tab-pane>
      <el-tab-pane label="记工统计-项目" name="count">
        <Count ref="count" :project="project"></Count>
      </el-tab-pane>
      <el-tab-pane label="记工统计-工人" name="countWorker" v-if="$route.query.type==='2'">
        <count-worker ref="countWorker" :project="project"></count-worker>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  name: "statisticsList",
  components: {
    Water: () => import("./components/water"), // 记工流水
    Count: () => import("./components/count"), // 记工统计-项目
    CountWorker: () => import("./components/CountWorker") // 记工统计-工人
  },
  props: {
    project: {
      type: [Object, undefined],
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      curTab: "water" // 当前选中的标签页
    }
  },
  methods: {
    getList(projectNo) {
      this.$refs[this.curTab].getList(projectNo)
    },
    tabClick({name}) {
      this.$refs[name].getList(this.project.no)
    }
  }
}
</script>

<style lang="scss" scoped>
.statistics-wrap {
  width: 100%;
}

.el-tabs {
  border: 1px solid #E4E7ED;
}

/deep/ .el-tabs__item.is-active {
  color: #B79255;
  font-weight: bold;

  &:hover {
    color: #B79255;
  }
}

/deep/ .el-tabs__active-bar {
  background-color: #B79255;
}

/deep/ .el-tabs__item {
  position: relative;
  font-size: 16px;


  &:after {
    position: absolute;
    top: 50%;
    right: 0;
    transform: translateY(-50%);
    content: '';
    height: 24px;
    width: 1px;
    background-color: #E4E7ED;
  }
}

.project_name {
  margin-bottom: 16px;
}

/deep/ .el-tabs__item:last-of-type {
  &:after {
    display: none;
  }
}

/deep/ .el-tabs__item:hover {
  color: #000;
}

/deep/ .el-tabs__header.is-top {
  margin: 0;
}

/deep/ .el-tabs__nav-wrap:after {
  height: 1px;
}

/deep/ .el-tabs__nav-wrap {
  padding: 0 20px;
}

.color666 {
  color: #666666;
}
</style>
